import {gql} from '@apollo/client';

// Story activity, as built in news-service ff6c97a (update to the plan, §4).
// Stories not yet sent for writing come from newsClusters; stories sent for
// writing from newsDraftRuns; the chip counts from newsStoryCounts.
//
// Not built in news-service yet, so their buttons are not shown:
// redispatchNewsCluster (a Try again now that also resets the tries) and
// rejectNewsCluster (Don't publish this story, before it is written).

export const GET_STORY_COUNTS = gql`
  query NewsStoryCounts($exchangeId: ID!, $sourceId: ID, $search: String) {
    newsStoryCounts(
      exchangeId: $exchangeId
      sourceId: $sourceId
      search: $search
    ) {
      ... on Error {
        message
      }
      ... on NewsStoryCounts {
        ready
        waiting
        writing
        inReview
        published
        notPublished
        failed
      }
    }
  }
`;

export const GET_NEWS_CLUSTERS = gql`
  query NewsClusters(
    $exchangeId: ID!
    $state: NewsClusterState
    $sourceId: ID
    $search: String
    $limit: Int
    $page: Int
  ) {
    newsClusters(
      exchangeId: $exchangeId
      state: $state
      sourceId: $sourceId
      search: $search
      limit: $limit
      page: $page
    ) {
      ... on Error {
        message
      }
      ... on NewsClusterList {
        pagination {
          page
          pages
          total
        }
        data {
          clusterId
          primaryTitle
          publishedDate
          outlets
          articleCount
          ready
          expiresAt
          articles {
            articleId
            outlet
            title
            url
          }
        }
      }
    }
  }
`;

export const GET_NEWS_DRAFT_RUNS = gql`
  query NewsDraftRuns(
    $exchangeId: ID!
    $status: NewsDraftRunStatus
    $sourceId: ID
    $search: String
    $limit: Int
    $page: Int
  ) {
    newsDraftRuns(
      exchangeId: $exchangeId
      status: $status
      sourceId: $sourceId
      search: $search
      limit: $limit
      page: $page
    ) {
      ... on Error {
        message
      }
      ... on NewsDraftRunList {
        pagination {
          page
          pages
          total
        }
        data {
          id
          clusterId
          requestedBy
          status
          title
          outlets
          sources {
            articleId
            outlet
            title
            url
          }
          startedAt
          lastAttemptAt
          publishedAt
          heldAt
          attempts
          maxAttempts
          willRetry
          nextAttemptAt
          failureKind
          failureCode
          lastError
          n8nExecutionId
          websiteNewsId
          draftId
        }
      }
    }
  }
`;

export const RUN_NEWS_PIPELINE_TICK = gql`
  mutation RunNewsPipelineTick($exchangeIds: [ID!], $skipIngestion: Boolean) {
    runNewsPipelineTick(
      exchangeIds: $exchangeIds
      skipIngestion: $skipIngestion
    ) {
      ... on Error {
        message
      }
      ... on NewsPipelineTickResult {
        status
        ingested
        clusters
        dispatched
        errors
      }
    }
  }
`;

// Write it now (plan update §4.5): writes a story waiting for a second
// website from its one report, or sends a failed story again while it has
// tries left. Either way the result is held in Review.
export const DISPATCH_NEWS_CLUSTER = gql`
  mutation DispatchNewsCluster($exchangeId: ID!, $clusterId: String!) {
    dispatchNewsCluster(exchangeId: $exchangeId, clusterId: $clusterId) {
      ... on Error {
        message
      }
      ... on NewsDraftRun {
        id
        status
      }
    }
  }
`;
